import { Duration } from "luxon";

export const formatIntervalOption = (minutes: number) => ({
  id: minutes,
  value: minutes,
  label: Duration.fromObject({ minutes }).rescale().toHuman(),
});
